import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BreakpointService } from '@optek/xm-bootstrap';
import { NavBarService } from './nav-bar/nav-bar.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {
  public color = 'default';
  public innerWidth: any;

  constructor(
    private router: Router,
    private breakpointService: BreakpointService,
    private navBarService: NavBarService,
  ) {
  }

  get isFullScreen() {
    return false;
  }

  get showMinisidebar() {
    return this.navBarService.showMinisidebar;
  }

  ngOnInit(): void {
    this.handleSidebarBreakpoint();
  }

  toggleSidebar() {
    this.navBarService.showMinisidebar = !this.navBarService.showMinisidebar;
  }

  handleSidebarBreakpoint() {
    this.router.events
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          if (this.breakpointService.isMaxWidthMd) {
            this.navBarService.showMinisidebar = true;
          }
        }
      });
  }

  @HostListener('window:resize')
  onResize() {
    this.handleLayout();
  }

  handleLayout() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1200) {
      this.navBarService.showMinisidebar = true;
    } else {
      this.navBarService.showMinisidebar = false;
    }
  }

}
